import classNames from 'classnames/bind';
import React from 'react';

import DrawCircle from './01_DrawCircle';
import DrawPolygon from './02_DrawPolygon';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const FenceTools = () => {
  return (
    <div className={cx('container')}>
      <div className={cx('header')}>
        <div className={cx('title')}>Drawing Fence</div>
      </div>
      <div className={cx('body')}>
        <DrawCircle />
        <DrawPolygon />
      </div>
    </div>
  );
};

export default FenceTools;
